import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatLabel } from '@angular/material/input';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';

@Component({
    selector: 'app-form-radio',
    templateUrl: './form-radio.component.html',
    styleUrls: ['./form-radio.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [ReactiveFormsModule, MatLabel, MatRadioGroup, MatRadioButton]
})
export class FormRadioComponent implements OnInit {
  config: FieldConfig;
  group: FormGroup;
  constructor() { }

  ngOnInit() {

  }

}
